/**
 * #1124 part B1 — tab-wide times of connection resets and resnapshot requests,
 * for the Data pressure card's "in the last 5 min" counts. Per event, never
 * per frame.
 *
 * Fixed size: one 64-slot ring of `performance.now()` stamps per kind,
 * overwrite-oldest. A ring full of events inside the window reads as a floor
 * ("64+"), which the card shows.
 */

export type ConnectionEventKind = 'reset' | 'resnapshot';

export const CONNECTION_EVENT_RING = 64;

const rings: Record<ConnectionEventKind, { times: Float64Array; next: number; filled: number }> = {
  reset: { times: new Float64Array(CONNECTION_EVENT_RING), next: 0, filled: 0 },
  resnapshot: { times: new Float64Array(CONNECTION_EVENT_RING), next: 0, filled: 0 },
};

export function noteConnectionEvent(kind: ConnectionEventKind): void {
  const r = rings[kind];
  r.times[r.next] = performance.now();
  r.next = (r.next + 1) % CONNECTION_EVENT_RING;
  if (r.filled < CONNECTION_EVENT_RING) r.filled += 1;
}

/** Events of `kind` at or after `sinceMonoMs` (a `performance.now()` value),
 *  capped at the ring size. */
export function connectionEventsSince(kind: ConnectionEventKind, sinceMonoMs: number): number {
  const r = rings[kind];
  let n = 0;
  for (let i = 0; i < r.filled; i += 1) if (r.times[i] >= sinceMonoMs) n += 1;
  return n;
}

export function __resetConnectionEventsForTests(): void {
  for (const r of Object.values(rings)) {
    r.times.fill(0);
    r.next = 0;
    r.filled = 0;
  }
}
